import React from "react";

import QuestionItem from "..";
import { TopicType } from "service/homework";

interface IProps {
    homeworkState: number;
    topics: TopicType[];
    onQuestionChange: (
        topicId: number,
        topicType: string,
        answerId: number | number[],
        value?: string
    ) => void;
}

export const Listening = ({
    topics,
    homeworkState,
    onQuestionChange
}: IProps) => {
    return (
        <>
            {topics.map((topic, index) => (
                <QuestionItem
                    item={topic}
                    canPastedText={false}
                    key={index}
                    topicId={parseInt(topic.topicId || "0")}
                    topicType={topic.topicType}
                    trunk={topic.trunk}
                    answers={topic.answers}
                    homeworkState={1}
                    onQuestionChange={onQuestionChange}
                    contentText={topic.contentText}
                />
            ))}
        </>
    );
};
